// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import DivisionSummary from '@deere/cps-it.warranty-model-factory/lib/division-summary';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../shared/components/labeled-string';
import {buildNumber} from '../../../shared/services/build-number';
import {getClassName} from '../services/get-class-name';

const DivisionSummaryPanel = props =>
    <div className='division-summary-panel'>
        <header>
            <FormattedMessage id='DIVISION_SUMMARY'/>
        </header>
        <div className='row division-overdue'>
            <LabeledString
                data={buildNumber(props.divisionSummary.divisionOverdue)}
                label='OVERDUE'
            />
            <span className={getClassName('dot-icon-red', props.divisionSummary.divisionOverdue)}/>
        </div>
        <div className='row division-due'>
            <LabeledString
                data={buildNumber(props.divisionSummary.divisionDue3Months)}
                label='DUE_WITHIN_3_MONTHS'
            />
            <span className={getClassName('dot-icon-yellow', props.divisionSummary.divisionDue3Months)}/>
        </div>
        <div className='row'>
            <LabeledString
                className='division-completed'
                data={buildNumber(props.divisionSummary.divisionCompl24Months)}
                label='COMPLETED_IN_LAST_24_MONTHS'
            />
        </div>
    </div>;

DivisionSummaryPanel.displayName = 'DivisionSummaryPanel';
DivisionSummaryPanel.propTypes = {
    divisionSummary: PropTypes.instanceOf(DivisionSummary).isRequired
};

export default DivisionSummaryPanel;



// WEBPACK FOOTER //
// ./src/reports/audit-status/components/division-summary-panel.js